(function () {
  'use strict';
  if (window.rcAuEngravingPreviewInstalled) return;
  window.rcAuEngravingPreviewInstalled = true;
  const stringsElement = document.getElementById('rc-apo-preview-strings');
  const strings = stringsElement ? JSON.parse(stringsElement.textContent) : {placeholder: 'Text', laser: 'Laser engraving preview'};
  const normalize = value => (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  const label = option => normalize(option.querySelector('.mw-text--style-strong')?.textContent);
  const usable = option => !option.classList.contains('mw-hidden') && option.getClientRects().length > 0;
  const selectedFont = option => {
    const checked = option?.querySelector('input:checked');
    const value = checked?.closest('.mw-option__value');
    const name = normalize(checked?.getAttribute('aria-label') || value?.querySelector('img')?.alt || value?.textContent);
    return name.includes('charm') ? 'Charm' : name.includes('kauf') ? 'Kaufmann' : 'Oswald';
  };
  let queued = false;
  function updateRoot(root) {
    root.querySelectorAll('.fonty').forEach(old => {
      const block = old.closest('.product-block');
      if (!block) return;
      old.hidden = true;
      old.querySelectorAll('input,select').forEach(field => { if (!field.disabled) field.disabled = true; });
      block.querySelectorAll('.preview-container,.collapsible-trigger-btn').forEach(element => { element.hidden = true; });
    });
    const options = Array.from(root.querySelectorAll('.mw-option')).filter(usable);
    const textOption = options.find(option => /add your text|engraving text|personali[sz]ation text|add initials/.test(label(option)) && option.querySelector('input[type="text"]:not(:disabled),textarea:not(:disabled)'));
    let preview = root.querySelector('.rc-apo-preview');
    if (!textOption) { preview?.remove(); return; }
    const input = textOption.querySelector('input[type="text"]:not(:disabled),textarea:not(:disabled)');
    const title = root.querySelector('h1,h2')?.textContent || '';
    const strap = /watch.*(?:strap|band)|(?:strap|band).*watch/i.test(title) || /watch.*(?:strap|band)/i.test(location.pathname);
    const fontOption = options.find(option => /font/.test(label(option)));
    const font = selectedFont(fontOption);
    if (!preview) {
      preview = document.createElement('div');
      preview.innerHTML = '<div class="rc-apo-preview__canvas" role="img"><span class="rc-apo-preview__text" aria-hidden="true"></span></div>';
    }
    const className = 'rc-apo-preview rc-apo-preview--' + (strap ? 'laserStrap' : 'laserWallet');
    if (preview.className !== className) preview.className = className;
    const previewAnchor = fontOption || textOption;
    if (preview.previousElementSibling !== previewAnchor) previewAnchor.insertAdjacentElement('afterend', preview);
    const text = input.value.trim() || strings.placeholder;
    const span = preview.querySelector('.rc-apo-preview__text');
    if (span.textContent !== text) span.textContent = text;
    span.style.fontFamily = '"' + font + '", ' + (font === 'Oswald' ? 'sans-serif' : 'cursive');
    const baseSize = font === 'Charm' ? 36 : font === 'Kaufmann' ? 40 : strap ? 34 : 32;
    span.style.fontSize = baseSize + 'px';
    const canvas = preview.querySelector('.rc-apo-preview__canvas');
    const available = Math.max(60, canvas.clientWidth - (strap ? 22 : 64));
    if (span.scrollWidth > available) span.style.fontSize = Math.max(12, baseSize * available / span.scrollWidth) + 'px';
    const description = strings.laser + ': ' + text;
    if (canvas.getAttribute('aria-label') !== description) canvas.setAttribute('aria-label', description);
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll('[id^="ProductSection-"]').forEach(updateRoot);
    });
  }
  document.addEventListener('input', event => { if (event.target.matches('.mw-option__control')) queue(); });
  document.addEventListener('change', event => { if (event.target.matches('.mw-option__control')) queue(); });
  new MutationObserver(queue).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'checked']});
  document.fonts?.ready.then(queue);
  document.fonts?.addEventListener('loadingdone', queue);
  document.addEventListener('shopify:section:load', queue);
  window.addEventListener('resize', queue, {passive: true});
  queue();
})();
